/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import SimpleButton from '@components/Buttons/SimpleButton';
import CardInfo2 from '@components/Card/CardInfo2';
import CardInfo3 from '@components/Card/CardInfo3';
import SectionTitle from '@components/Headings/SectionTitle';
import TopKolam from '@components/Headings/TopKolam';
import React from 'react';

/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const ProgramHighlights = React.memo(({ pageData, pageConfig, sectionContent, region, language }) => {
    return (
        <Box
            paddingBottom={"60px"}
            paddingTop={{ sm: "20px", base: "20px", md: "20px" }}>
            {sectionContent.map((section, index) => {
                if (section?._modelApiKey === 'section_title') {
                    return (
                        <Box key={index}>
                            <SectionTitle
                                titleObj={section}
                                titleDecoration={section?.titleDecoration}
                                // maxW={{ base: '280px', sm: '350px', md: '663px' }}
                                mx={{ base: '17px', md: 'auto' }}
                                color="black"
                            />
                        </Box>
                    );
                }
                else if (section?._modelApiKey === "top_kolam") {
                    return (
                        <Box key={index} marginTop={"-30px"}>
                            <TopKolam
                                sectionContent={section}
                            />
                        </Box>
                    )
                }
                else if (section?._modelApiKey === 'card_info3_column_group') {
                    return (
                        <Box key={index}
                            marginTop={{ base: "42px", sm: "42px", md: "98px" }} >
                            <CardInfo3
                                pageConfig={pageData?.pageConfig}
                                sectionContent={section}
                            />
                        </Box>
                    )
                }
                else if (section?._modelApiKey === 'card_info2_column_group') {
                    return (
                        <Box display="flex" justifyContent={"center"} alignItems={"center"} marginTop={{ base: "20px", sm: "20px", md: "20px", lg: "126px" }} mx={{ base: "35px", sm: "35px", md: "auto" }}
                            flexWrap={{ sm: "wrap", md: "wrap", lg: "" }}
                            width={{ sm: "50%", md: "50%", lg: "50%", xl: "100%" }}
                        >
                            <CardInfo2
                                pageConfig={pageData?.pageConfig}
                                sectionContent={section}
                                region={region}
                                lang={language}
                            />
                        </Box>
                    )
                }
                else if (section?._modelApiKey === 'simple_button') {
                    return (
                        <Box key={index}
                            marginTop={{ base: "30px", sm: "30px", md: "60px" }}
                        >
                            <SimpleButton
                                pageConfig={pageConfig}
                                style={section}
                                region={region}
                                lang={language}
                                mx="auto"
                            />
                        </Box>
                    )
                }
            })}
        </Box>
    );
});

export default ProgramHighlights;
